import React from 'react'
import NavHeader from '../components/NavHeader/NavHeader'
import Footer from '../components/Footer/Footer'
import { Outlet } from 'react-router-dom'
import './Layout.css'

const Layout: React.FC = () => {
  return (
    <div className='d-flex flex-column min-vh-100'>
      <NavHeader />
      <Outlet />
      <Footer />
    </div>
  )
}

export default Layout